/// <amd-module name="Artifacts/Feed/helpers/ArtifactsSettingsHelpers" />
import {
  IArtifactsSettingsData,
  IRoleAssignment,
} from "Artifacts/Feed/services/ArtifactsSettingsService";
import { GlobalRole } from "Artifacts/Root/web-apis/contracts/Feed";
import { IIdentity } from "VSS/Features/Identities/IdentityService";

export function getPermissionDelta(
  current: IArtifactsSettingsData,
  target: IArtifactsSettingsData,
  everyoneGroupId: string,
): IRoleAssignment[] {
  const initialStateMap = new Map<string, GlobalRole>();
  const currentStateMap = new Map<string, GlobalRole>();

  const setInitialState = (list: IIdentity[], role: GlobalRole) => {
    for (const identity of list) {
      initialStateMap.set(identity.localId!, role);

      // after processing the real current state, any removed ids will be left mapped to None
      currentStateMap.set(identity.localId!, GlobalRole.None);
    }
  };

  setInitialState(current.creatorIds, GlobalRole.FeedCreator);
  setInitialState(current.adminIds, GlobalRole.Administrator);

  const setCurrentState = (list: IIdentity[], role: GlobalRole) => {
    for (const identity of list) {
      currentStateMap.set(identity.localId!, role);
    }
  };

  // do creator, then admin, so that admin takes precedence.
  setCurrentState(target.creatorIds, GlobalRole.FeedCreator);
  setCurrentState(target.adminIds, GlobalRole.Administrator);

  const modifiedRoles: IRoleAssignment[] = [];
  currentStateMap.forEach((currentRole, tfid) => {
    if (currentRole !== initialStateMap.get(tfid)) {
      modifiedRoles.push({ tfid, role: currentRole });
    }
  });

  // set new everyoneCreator last
  if (target.everyoneIsCreator !== current.everyoneIsCreator) {
    modifiedRoles.push({
      tfid: everyoneGroupId,
      role: target.everyoneIsCreator ? GlobalRole.FeedCreator : GlobalRole.None,
    });
  }

  return modifiedRoles;
}
